import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'giro-react-toolkit/source/Translation';
import ClassNames from 'classnames';
/**
 * Component for form group, consists of a label, an icon and
 * a form element passed as a child.
 */
class FormGroup extends Component {
   constructor(props) {
      super(props);
      this.state = {
         hasFocus: false
      }
   }

   /**
    * renders the FormGroups component
    */
   render() {
      const formGroupClassNames = ClassNames(
         this.props.className,
         "form-group",
         { "form-group--focused": this.state.hasFocus }
      );

      var formGroup = this;

      var childWithFocus = React.Children.map(this.props.children, function (child) {
         return React.cloneElement(child, {
            onFocus:() => formGroup.setState({ hasFocus: true }),
            onBlur: () => formGroup.setState({ hasFocus: false })
         });
      });

      return (
         <div className={formGroupClassNames} role="group" aria-labelledby={this.props.labelId}>
            <div className={"form-group__icon form-group__icon--"+ this.props.iconName } />
            <div className="form-group__field">
               <label id={this.props.labelId}>
                  <Translation resourceKey={ this.props.resourceKey } />
                  {childWithFocus}
               </label>
            </div>
         </div>
      );
   }
}

FormGroup.propTypes = {
   /**
    * Class name to apply to form group
    */
   className: PropTypes.string,
   /**
    * Icon name to display in form group
    */
   iconName: PropTypes.string,
   /**
    * Id for label
    */
   labelId: PropTypes.string,
   /**
    * resource key for label text
    */
   resourceKey: PropTypes.string
}

export default FormGroup;
